import { LocalDate } from "@js-joda/core";
import currency from "currency.js";
import h from "trader-hyperscript";
import { Form, constantField, selectBox } from "trader.ts/ui.forms";
import * as style from "../../../styles/style.css.classes";
import {
  downloadCsvFromTable,
  downloadXlsFromTable,
} from "../../client/downloadtable";
import { period } from "../../domain/periods";
import { absCurrency } from "../../lib/currency";
import { dateInDaterange } from "../../lib/time";
import {
  renderCurrency,
  renderedInvoiceSubjectToHtml,
  renderFirstNameLastName,
  renderInvoiceSubjectForOverviews,
} from "../../render";
import * as routes from "../../routes";
import { renderPeriod } from "../../translations_specific";
import {
  renderReportResult,
  runQueryOnFormChange,
} from "../finance_invoices/client";

export function render(opts: {
  periods: period[];
}): HTMLElement | HTMLElement[] {
  const today = LocalDate.now();

  const form = new Form({})
    .addField("period", [], async () =>
      selectBox({
        initial:
          opts.periods.find((p) =>
            dateInDaterange(
              { date: today },
              { from: p.firstday, until: p.lastday },
            ),
          ) || opts.periods[0],

        values: opts.periods,
        show: (p) => renderPeriod(p.firstday, p.lastday),
        label: "Schooljaar",
        // render: radioFieldCheckboxRender,
      }),
    )
    .addField("dummy", [], () => constantField(null, { render: <div></div> }))
    .build();

  const res = runQueryOnFormChange(
    form.s,
    routes.queryInvoicesToReimburseSpec,
    (t) => t,
  );

  const id = "classy-table-id";

  return (
    <main style="max-width: unset;">
      <section
        className={style.cancel_main_margins}
        style="background-color: var(--grey-200); padding-bottom: 32px;"
      >
        {"Hier krijg je een overzicht van alle facturen waar het openstaande bedrag negatief is, dus waar er geld moet teruggestort worden aan de student."}
      </section>

      <section
        className={style.cancel_main_margins + style.equal_columns}
        style="margin-top: -32px;"
      >
        {form.render()}
      </section>

      {renderReportResult(res, (rows): HTMLElement => {
        const downloadLinks = (
          <section style="text-align: right;">
            <div style="font-size: 0.85em;">
              <a
                style="margin-right: 8px;"
                onclick={() =>
                  downloadXlsFromTable("OverzichtTerugTeStorten", id)
                }
              >
                {"Download als xls"}
              </a>
              <a
                onclick={() =>
                  downloadCsvFromTable("OverzichtTerugTeStorten", id)
                }
              >
                {"Download als csv"}
              </a>
            </div>
          </section>
        );
        const headerRow = (
          <tr style="position: sticky; top: 0px; background-color: white;">
            <th>{"Student"}</th>
            <th style="display: none;">{"Emailadres" + " 1"}</th>
            <th style="display: none;">{"Emailadres" + " 2"}</th>
            <th style="display: none;">{"Emailadres" + " 3"}</th>
            <th style="display: none;">{"Emailadres" + " 4"}</th>
            <th>{"Les"}</th>
            <th>{"Factuur"}</th>
            <th>{"Terug te storten"}</th>
          </tr>
        );
        function showEmail(emails: { email: string }[], index: number) {
          if (emails && emails[index]) {
            return emails[index].email;
          }
          return "";
        }
        const renderedRows =
          rows === null
            ? [<tr></tr>]
            : rows
                .orderBy((r) => renderFirstNameLastName(r.subject.student))
                .map((row) => {
                  return (
                    <tr>
                      <td>
                        <a
                          href={routes.studentOverviewRoute.link({
                            studentid: row.subject.student.id,
                          })}
                        >
                          {renderFirstNameLastName(row.subject.student)}
                        </a>
                      </td>
                      <td style="display: none">
                        {showEmail(row.student_emails, 0)}
                      </td>
                      <td style="display: none">
                        {showEmail(row.student_emails, 1)}
                      </td>
                      <td style="display: none">
                        {showEmail(row.student_emails, 2)}
                      </td>
                      <td style="display: none">
                        {showEmail(row.student_emails, 3)}
                      </td>
                      <td>
                        {renderedInvoiceSubjectToHtml(
                          renderInvoiceSubjectForOverviews(row.subject),
                        )}
                      </td>
                      <td>
                        <a
                          href={routes.invoicedetailsRoute.link({
                            invoiceid: row.invoiceid,
                            edit: false,
                          })}
                        >
                          {"#" + row.externalid}
                        </a>
                      </td>
                      <td>{renderCurrency(absCurrency(row.amount_left))}</td>
                    </tr>
                  );
                });
        const renderedTotal =
          rows === null ? (
            <span></span>
          ) : (
            <tr style="font-weight: bold;background-color: var(--grey-100);">
              <td>{"Totaal" + ": " + rows.length}</td>
              <td style="display: none"></td>
              <td style="display: none"></td>
              <td style="display: none"></td>
              <td style="display: none"></td>
              <td></td>
              <td></td>
              <td style="width: 100px;">
                {renderCurrency(
                  rows.reduce(
                    (acc, row) => acc.add(absCurrency(row.amount_left)),
                    currency(0),
                  ),
                )}
              </td>
            </tr>
          );
        return (
          <div>
            {downloadLinks}
            <table id={id}>
              {headerRow}
              {renderedRows}
              {renderedTotal}
            </table>
          </div>
        );
      })}
    </main>
  );
}
